// extracted by mini-css-extract-plugin
export default {"component":"RegisterDeviceComponent_component__YRme8"};